module.exports = __webpack_public_path__ + "img/40f1.fb3113ac.jpg";